import { IconWrapper } from '../runtime';
export default IconWrapper('letter-ascending', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M12.2534 1.74976V14.2498M12.2534 14.2498L10.4404 12.4678M12.2534 14.2498L14.0664 12.4678",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M3.75 12.9998H6.75",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M2.75 14.2498L4.97308 8.91437C5.07564 8.66822 5.42436 8.66822 5.52692 8.91437L7.75 14.2498",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M2.75 1.74976H7.35C7.6383 1.74976 7.76064 2.11677 7.53 2.28976L2.97 5.70976C2.73936 5.88274 2.8617 6.24976 3.15 6.24976H7.75",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});